import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=a0639f88&scoped=true&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=a0639f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0639f88",
  null
  
)

export default component.exports